import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const NotificationConfigurationList = Loadable(
  lazy(() => import("features/notification/configuration/components/List"))
);
const NotificationConfigurationPage = Loadable(
  lazy(() => import("features/notification/configuration/components/Page"))
);

const routes = {
  path: "configuration",
  children: [
    { path: "", element: <NotificationConfigurationList /> },
    { path: "add", element: <NotificationConfigurationPage /> },
    {
      path: "edit/:notificationConfigurationID?",
      element: <NotificationConfigurationPage />,
    },
  ],
};

export default routes;
